<!--
  @component

  The oc-block component is used for structuring elements.

  ```html
  <oc-block-v1>
      Lorem ipsum dolor sit amet
  </oc-block-v1>
  ```

  @slot required `default` Main content of the block component
-->
<svelte:options
  customElement={{
    tag: "oc-block-v1",
    props: {
      noPadding: { type: "Boolean", attribute: "no-padding", reflect: true },
    },
  }}
/>

<script lang="ts">
  /**
 *
 *
 */
  export const noPadding = false;
</script>

<slot />

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "./BlockV1.config" as config;

  $oc-block-background-color: tokens.$oc-base-color-white;

  :host {
    display: config.$oc-block-display;
    background: $oc-block-background-color;
  }

  :host(:not([no-padding])) {
    padding: config.$oc-block-padding;
  }
</style>
